import * as yup from 'yup';

import { ERRORS_TEXTS, FIELDS_LIMITS } from '../../../../../../const/validation';

export const schema = yup.object({
  title: yup.string().required(ERRORS_TEXTS.required),
  tagline: yup.string().max(FIELDS_LIMITS.tagline, ERRORS_TEXTS.tagline).nullable().default(null),
  author: yup.string().required(ERRORS_TEXTS.required),
  managerIds: yup.array().of(yup.string()).default([]),
  isBlogger: yup.boolean().default(false),
  welcomeLetter: yup.string().default(''),
  subscription: yup.string().default(''),
  profile: yup.string().nullable().default(null),
  currency: yup.string().required(ERRORS_TEXTS.required),
  minSumma: yup.number().positive(ERRORS_TEXTS.positive).required(ERRORS_TEXTS.required),
  recommendedAmount: yup.number().positive(ERRORS_TEXTS.positive).nullable().default(null),
  capacity: yup.number().positive(ERRORS_TEXTS.positive).nullable().default(null),
  estimatedProfit: yup.number().positive(ERRORS_TEXTS.positive).nullable().default(null),
  estimatedTradesPerWeek: yup.number().positive(ERRORS_TEXTS.positive).nullable().default(null),
  index: yup.string().required(ERRORS_TEXTS.required),
  period: yup.string().required(ERRORS_TEXTS.required),
  maxInstrumentWeight: yup.number().positive(ERRORS_TEXTS.positive).required(ERRORS_TEXTS.required),
  maxSignalWeight: yup.number().positive(ERRORS_TEXTS.positive).nullable().default(null),
  leverage: yup.number().min(0, ERRORS_TEXTS.positive).required(ERRORS_TEXTS.required),
  recalcMode: yup.string().required(ERRORS_TEXTS.required),
  hasParent: yup.boolean().default(false),
  parent: yup
    .string()
    .nullable()
    .default(null)
    .when('hasParent', {
      is: true,
      then: (s) => s.required(ERRORS_TEXTS.required),
    }),
});
